import { render } from "./favorite_team_dropdown.vue?vue&type=template&id=9838a682"
import script from "./favorite_team_dropdown.vue?vue&type=script&lang=js"
export * from "./favorite_team_dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__